/*

type
  selectOne: select one of multiple options
  selectOneWithInput: select one of multiple options & add input field into one of these
  selectMultiple: select some of multiple options
    answer 'none' will deselect the other options
  number: select a number with an incrementor
    answer config: min, max, default, step
  info: just some information, we go to the next question
  end: this is the last slide, we end the tool here

key
  this is used for translations

info
  wether or not to show the info button (make sure to add info in the translations)

for
  this indicates for what the question is used, system or buffer

answers
  its key is used for the translations
  next: the next question
  nextIf: next question, related to previous selected criteria
  icon: the icon name
  svg: an svg icon, imported here
  iconSize: default is xxl
  criteria: what should be saved to the store to select the final system

criteria
  what should be saved to the store to select the final system
  it's the default for this question, independent of the answers

next
  is the default next question

nextMap
  is a map of how to decide to which question we should go next (used for 'selectMultiple')

nextIf
  next question, related to previous selected criteria
  for: in which 'for' to look for the criteria
  key: the criteria key
  value: the value to match the criteria
  next: the next question if the condition is true

nextIfInputIsHigherThen
  next question if input is higher then certain amount
  value: the value to check if the answer is higher then this
  next: the next question if the condition is true

*/

import TemperatureZone1 from '../../../img/advisory-tool/svg/zone1.svg';
import TemperatureZone2 from '../../../img/advisory-tool/svg/zone2.svg';
import TemperatureZone3 from '../../../img/advisory-tool/svg/zone3.svg';

export const start = {
  system: 2,
};

export default {
  2: {
    type: 'selectOne',
    key: 'outsideSpace',
    info: true,
    for: 'system',
    answers: {
      yes: { next: 3, icon: 'yes' },
      no: { next: 7, icon: 'no' },
      dunno: { next: 3, icon: 'question', info: true },
    },
  },
  3: {
    type: 'selectOne',
    key: 'buildYear',
    info: false,
    for: 'system',
    answers: {
      early: { next: 4, icon: 'houseEarly', criteria: { isolation_degree: 2 } },
      recent: { next: 5, icon: 'houseRecent', criteria: { isolation_degree: 0.95 } },
      new: { next: 5, icon: 'houseNew', criteria: { isolation_degree: 0.6 } },
    },
  },
  4: {
    type: 'selectMultiple',
    key: 'isolation',
    info: false,
    for: 'system',
    answers: {
      roof: { icon: 'insulationRoof', criteria: { isolation: -0.3 } },
      wall: { icon: 'insulationWall', criteria: { isolation: -0.35 } },
      floor: { icon: 'insulationFloor', criteria: { isolation: -0.2 } },
      window: { icon: 'insulationWindow', criteria: { isolation: -0.15 } },
      none: { icon: 'no', criteria: { isolation: 0 } },
    },
    next: 5,
    nextMap: [
      { answers: ['none'], next: 8 },
    ],
  },
  5: {
    type: 'selectOne',
    key: 'heatingType',
    info: false,
    for: 'system',
    answers: {
      radiators: { next: 9, icon: 'radiators', criteria: { out_temperature: 55 } },
      radiatorsAndFloor: { next: 9, icon: 'radiatorsAndFloor', criteria: { out_temperature: 45 } },
      floor: { next: 9, nextIf: { key: 'isolation_degree', value: 0.6, for: 'system', next: 6 }, icon: 'floorHeating', criteria: { out_temperature: 35 } },
    },
  },
  6: {
    type: 'selectOne',
    key: 'extraSpaceForBoiler',
    info: false,
    for: 'system',
    answers: {
      yes: { next: 10, icon: 'yes', criteria: { heat_pump_energy: 'all electric' } },
      no: { next: 9, icon: 'no' },
    },
  },
  7: {
    type: 'end',
    key: 'notSuited',
    info: false,
    for: 'system',
  },
  8: {
    type: 'end',
    key: 'maybeSuited',
    info: false,
    for: 'system',
  },
  9: {
    type: 'selectOne',
    key: 'hybridHeatPump',
    info: false,
    for: 'system',
    answers: {
      yes: { next: 23, icon: 'yes', criteria: { heat_pump_energy: 'hybride', kettle_type: 'nieuwe cv' } },
      no: { next: 30, icon: 'no', criteria: { heat_pump_energy: 'hybride', kettle_type: 'cv handhaven' } },
    },
  },
  10: {
    type: 'selectOne',
    key: 'allElectricHeatpump',
    info: false,
    for: 'system',
    next: 20,
    criteria: { heat_pump_energy: 'all electric' },
    answers: {
      yes: { next: 20, icon: 'yes', criteria: { heat_pump_energy: 'all electric' } },
      no: { next: 20, icon: 'no', criteria: { heat_pump_energy: 'hybride' } },
    },
  },
  20: {
    type: 'selectOne',
    key: 'household',
    info: true,
    for: 'buffer',
    answers: {
      1: { next: 21, icon: 'household1', criteria: { household: 1 } },
      2: { next: 21, icon: 'household2', criteria: { household: 2 } },
      3: { next: 21, icon: 'household3', criteria: { household: 3 } },
      4: { next: 21, icon: 'household4', criteria: { household: 4 } },
      5: { next: 21, icon: 'household5', criteria: { household: 5 } },
      6: { next: 40, icon: 'household6' },
    },
  },
  21: {
    type: 'selectOne',
    key: 'temperatureZones',
    info: true,
    for: 'system',
    answers: {
      1: { next: 22, svg: TemperatureZone1, criteria: { heat_pump_series: ['Mercuria', 'Eria Tower', 'Neptuna'] } },
      2: { next: 22, svg: TemperatureZone2, criteria: { heat_pump_series: ['Neptuna'] } },
      3: { next: 22, svg: TemperatureZone3, criteria: { heat_pump_series: ['Neptuna'] } },
      dunno: { next: 22, icon: 'question', info: true, criteria: { heat_pump_series: ['Mercuria', 'Eria Tower', 'Neptuna', 'Elga'] } },
    },
  },
  22: {
    type: 'selectOne',
    key: 'cooling',
    info: true,
    for: 'system',
    answers: {
      yes: { next: 25, icon: 'yes' },
      no: { next: 25, icon: 'no' },
      dunno: { next: 25, icon: 'question', info: true },
    },
  },
  23: {
    type: 'selectOne',
    key: 'hotWaterNeed',
    info: false,
    for: 'system',
    answers: {
      6: { next: 24, icon: 'cw3', criteria: { cw_class: 3 } },
      13: { next: 24, icon: 'cw4', criteria: { cw_class: 4 } },
      17: { next: 24, icon: 'cw5', criteria: { cw_class: 5 } },
      20: { next: 24, icon: 'cw6', criteria: { cw_class: 6 } },
    },
  },
  24: {
    type: 'selectOne',
    key: 'flueGasConnection',
    info: false,
    for: 'system',
    answers: {
      excentric: { next: 30, icon: 'excentric', criteria: { gas_connection_type: 'Excentrisch' } },
      concentric: { next: 30, icon: 'concentric', criteria: { gas_connection_type: 'Concentrisch' } },
      dunno: { next: 30, icon: 'question', info: true, criteria: { gas_connection_type: 'Excentrisch' } },
    },
  },
  25: {
    type: 'selectOne',
    key: 'bathroom',
    info: false,
    for: 'buffer',
    answers: {
      douche: { next: 28, icon: 'shower', criteria: { bath_fill: 0 } },
      doucheAndBath: { next: 26, icon: 'bathAndShower' },
      multiple: { next: 40, icon: 'multipleBathrooms' },
    },
  },
  26: {
    type: 'selectOne',
    key: 'bath',
    info: false,
    for: 'buffer',
    answers: {
      small: { next: 27, icon: 'bathSmall', criteria: { bath_type: 100 } },
      normal: { next: 27, icon: 'bathNormal', criteria: { bath_type: 140 } },
      large: { next: 27, icon: 'bathLarge', criteria: { bath_type: 200 } },
      extraLarge: { next: 27, icon: 'bathExtraLarge', criteria: { bath_type: 250 } },
    },
  },
  27: {
    type: 'selectOne',
    key: 'bathFills',
    info: false,
    for: 'buffer',
    answers: {
      1: { next: 28, icon: 'bathX1', criteria: { bath_fill: 1 } },
      2: { next: 28, icon: 'bathX2', criteria: { bath_fill: 2 } },
      3: { next: 40, icon: 'bathX3' },
    },
  },
  28: {
    type: 'selectOne',
    key: 'shower',
    info: false,
    for: 'buffer',
    answers: {
      6: { next: 30, icon: 'waterDrop1', criteria: { shower_type: 5 } },
      10: { next: 30, icon: 'waterDrop2', criteria: { shower_type: 7 } },
      13: { next: 30, icon: 'waterDrop3', criteria: { shower_type: 9 } },
      17: { next: 30, icon: 'waterDrop4', criteria: { shower_type: 11 } },
      20: { next: 30, icon: 'waterDrop5', criteria: { shower_type: 15 } },
    },
  },
  30: {
    type: 'selectOneWithInput',
    key: 'roomVolume',
    info: true,
    for: 'system',
    answers: {
      input: { criteria: { room_volume: '{input}' } },
      dunno: { next: 31, icon: 'question' },
    },
    nextIfInputIsHigherThen: {
      value: 1000,
      next: 40,
    },
    next: 33,
  },
  31: {
    type: 'selectOneWithInput',
    key: 'floorArea',
    info: false,
    for: 'system',
    answers: {
      input: { criteria: { floor_area: '{input}' } },
    },
    next: 32,
  },
  32: {
    type: 'selectOne',
    key: 'ceilingHeight',
    info: false,
    for: 'system',
    answers: {
      low: { next: 33, icon: 'heightLow', criteria: { ceiling_height: 2.45 } },
      average: { next: 33, icon: 'heightMedium', criteria: { ceiling_height: 2.55 } },
      high: { next: 33, icon: 'heightHigh', criteria: { ceiling_height: 2.65 } },
    },
  },
  33: {
    type: 'number',
    key: 'temperature',
    info: false,
    for: 'system',
    answers: {
      input: { default: 21, min: 18, max: 24, step: 0.5, criteria: { apartment_temperature: '{input}' } },
    },
    next: 34,
  },
  34: {
    type: 'selectOne',
    key: 'unitType',
    info: false,
    for: 'system',
    answers: {
      free: { next: 35, icon: 'houseFreestanding', criteria: { apartment_type: 1 } },
      twoInOne: { next: 35, icon: 'houseCombined', criteria: { apartment_type: 0.95 } },
      row: { next: 35, icon: 'houseRow', criteria: { apartment_type: 0.9 } },
      apartment: { next: 35, icon: 'houseAppartment', criteria: { apartment_type: 0.85 } },
    },
  },
  35: {
    type: 'selectOne',
    key: 'pumpType',
    info: false,
    for: 'system',
    answers: {
      mono: { next: 'result', info: true, criteria: { pump_type: 'Mono', criterion_type: 'Prijs' } },
      split: { next: 'result', info: true, criteria: { pump_type: 'Split', criterion_type: 'Prijs' }, nextIf: { key: 'cw_class', value: [4, 5], for: 'system', next: 36 } },
    },
  },
  36: {
    type: 'selectOne',
    key: 'allInOne',
    info: false,
    for: 'system',
    answers: {
      yes: { next: 'result', info: true, icon: 'yes', criteria: { pump_type: 'All-in-one', criterion_type: 'Prijs' } },
      no: { next: 'result', info: true, icon: 'no', criteria: { pump_type: 'Split', criterion_type: 'Prijs' } },
    },
  },
  40: {
    type: 'end',
    key: 'customization',
    info: false,
    for: 'system',
  },
};



// WEBPACK FOOTER //
// ./js/views/advisory-tool/config.js